document.addEventListener("DOMContentLoaded", () => {
  const $header = document.querySelector(".js-header");
  if (!$header) return;

  const $stickyContents = document.querySelectorAll(".o-grid__item--sticky");
  const isAdmin = document.body.classList.contains("admin-bar");

  let lastScroll = 0;
  let ticking = false;
  let isSticky = false;

  function isMenuOpen() {
    return $header.classList.contains("is-open");
  }

  function onScroll() {
    const scrollY = window.scrollY;

    // Gestion sticky
    if (scrollY > 200 && !isSticky && !isMenuOpen()) {
      $header.classList.add("sticky");
      $header.classList.remove("top");
      isSticky = true;
    } else if (scrollY < 150 && isSticky && !isMenuOpen()) {
      $header.classList.remove("sticky");
      $header.classList.add("top");
      isSticky = false;
    }

    // Gestion hide/show
    if (!isMenuOpen() && scrollY > 140) {
      if (scrollY < lastScroll) {
        $header.classList.remove("header-hidden");
        if (isAdmin) $header.style.top = "50px";
        $stickyContents.forEach(el => el.style.top = "200px");
      } else {
        $header.classList.add("header-hidden");
        if (isAdmin) $header.style.top = "0";
        $stickyContents.forEach(el => el.removeAttribute("style"));
      }
    } else {
      $header.classList.remove("header-hidden");
      if (isAdmin && scrollY === 0) {
        $header.style.top = "0";
      }
    }

    lastScroll = scrollY;
    ticking = false;
  }

  function requestTick() {
    if (!ticking) {
      requestAnimationFrame(onScroll);
      ticking = true;
    }
  }

  window.addEventListener("scroll", requestTick);
});
